/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Button,
  Checkbox,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid2,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  Link as LinkMaterial,
  InputAdornment,
  TextField,
  Badge,
} from '@mui/material';
import { Dashboard as DashboardLayout } from 'layouts';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useDispatch, useSelector } from 'react-redux';
import { enUS, es } from 'date-fns/locale';
import { Events, Frecuency, HarmonicChart, LineChart } from './components';
import {
  getChargeDashboard10MinutalPro,
  getChargeDashboard5MinutalPro,
  getChargeDashboardHarmonicPro,
  getChargeDashboardNotification,
  getChargeDashboardProFlickerPlt,
  getChargeProReport,
  getChargeProReportPDF,
} from 'js/actions/chargeDashboardProActions';
import { ReactComponent as IconSVG } from './components/i.svg';
import {
  Add,
  Close,
  Delete,
  Description,
  Email,
  ErrorOutline,
  Person,
} from '@mui/icons-material';
import TenMinutalChart from './components/TenMinutalChart';
import { Card } from 'components';
import { NavLink, useLocation } from 'react-router-dom';
import { ShareButton } from 'components/Download';
import { PDF } from 'icons/PDF';
import Swal from 'sweetalert2';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { isAllowed } from 'helpers';
import axios from 'axios';
import theme from 'theme';
import { useIntl } from 'react-intl';
import getToken from 'helpers/auth';

function formatDate(date) {
  if (!date) return '';
  if (typeof date === 'object') {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}${month}${day}${hours}${minutes}`;
  }
}

const typeDataLabels = {
  thd_corriente: 'THD Corriente',
  thd_voltaje: 'THD Voltaje',
  v_Harmonics: 'Voltage Harmonic',
  i_Harmonics: 'Current Harmonic',
  v_InterHarmonics: 'Voltage InterHarmonic',
  i_InterHarmonics: 'Current InterHarmonic',
  flicker_Pst: 'Fluctuación de Tensión a Corto Plazo',
  frecuencia: 'Frecuencia',
  corriente_rms: 'Corriente RMS',
  voltaje_rms: 'Voltaje RMS',
  demanda_activa: 'Demanda Activa',
  demanda_reactiva: 'Demanda Reactiva',
  fp: 'Factor de Potencia',
  total_fp: 'Factor de Potencia Total',
  consumo_activa: 'Consumo Activo',
  consumo_reactiva: 'Consumo Reactivo',
};

export default function ChargeDashboardPro() {
  // Obtener el estado de la ubicación
  const state = useLocation().state;
  const group = state.group ? state.group : null;
  const meter = state.meter ? state.meter : null;
  // Obtener traducciones
  const intl = useIntl();
  // Obtener el usuario del localStorage
  const user = useSelector((state) => state.user.user);
  // Referencia para el dashboard
  const dashboardRef = useRef(null);
  // Estados para las fechas
  const [selectedStartDate, setSelectedStartDate] = useState(
    new Date('2025-06-18T00:00:00') // Fecha de inicio por defecto
  );
  const [selectedEndDate, setSelectedEndDate] = useState(
    new Date('2025-06-18T23:59:59') // Fecha de fin por defecto
  );
  const [selectedStartDateReport, setSelectedStartDateReport] = useState(
    new Date()
  );
  const [selectedEndDateReport, setSelectedEndDateReport] = useState(
    new Date()
  );
  // Estados para los tipos de datos
  const [typeData, setTypeData] = useState([]);
  // Harmonicos
  const [harmonics, setHarmonics] = useState([]);
  // Fases
  const [phases, setPhases] = useState([]);
  // Contact
  const [contact, setContact] = useState([]);
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  // Abrir modales
  const [openReport, setOpenReport] = useState(false);
  const [openReportPDF, setOpenReportPDF] = useState(false);
  const [openEvents, setOpenEvents] = useState(false);
  // Carga de datos
  const [isBlocking, setIsBlocking] = useState(false);
  // Ref
  const hasInitialized = useRef(false);
  // Redux
  const dispatch = useDispatch();
  const {
    TenMinutal,
    TenMinutalLoading,
    TenMinutalError,
    FiveMinutal,
    FiveMinutalLoading,
    FiveMinutalError,
    Harmonic,
    HarmonicLoading,
    HarmonicError,
    FlickerPlt,
    Notification,
  } = useSelector((state) => state.chargeDashboardPro);
  const { charge } = useLocation().state;
  const charge_id = charge?.charge?.charge_pro; // ID de la tienda
  // Locale
  const localeNav = useSelector((state) => state.prefs.locale);
  const locale = localeNav === 'es-MX' ? es : enUS;
  // Manejar cambios en las fechas
  const handleStartDateChange = (newValue) => {
    setSelectedStartDate(newValue);
  };

  const handleEndDateChange = (newValue) => {
    setSelectedEndDate(newValue);
  };
  // Manejar cambios en las fechas en reportes
  const handleStartDateChangeReport = (newValue) => {
    setSelectedStartDateReport(newValue);
  };

  const handleEndDateChangeReport = (newValue) => {
    setSelectedEndDateReport(newValue);
  };

  // Abrir modales
  const handleOpenReport = () => {
    setOpenReport(true);
  };
  const handleOpenReportPDF = () => {
    setOpenReportPDF(true);
  };
  // Cerrar modales
  const handleCloseReport = () => {
    setOpenReport(false);
    setHarmonics([]);
    setPhases([]);
    setTypeData([]);
  };
  const handleCloseReportPDF = () => {
    setOpenReportPDF(false);
    setHarmonics([]);
    setPhases([]);
    setTypeData([]);
  };
  // Agregar contactos
  const handleAddContact = () => {
    if (contactName && contactEmail) {
      setContact([...contact, { name: contactName, email: contactEmail }]);
      setContactName('');
      setContactEmail('');
    }
  };
  // Eliminar contacto
  const handleRemoveContact = (index) => {
    const newContact = [...contact];
    newContact.splice(index, 1);
    setContact(newContact);
  };
  // Carga de datos
  const setBlocking = (value) => {
    setIsBlocking(value);
    if (!value) {
      setHarmonics([]);
      setPhases([]);
      setTypeData([]);
      setSelectedStartDateReport(new Date());
      setSelectedEndDateReport(new Date());
      setContact([]);
      setContactName('');
      setContactEmail('');
      handleCloseReport();
      handleCloseReportPDF();
    }
  };

  const handleChangeTypeData = (event) => {
    const {
      target: { value },
    } = event;
    setTypeData(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
  };

  const handleChangePhases = (event) => {
    const {
      target: { value },
    } = event;
    setPhases(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
  };

  const handleChangeHarmonics = (event) => {
    const {
      target: { value },
    } = event;
    setHarmonics(
      // On autofill we get a stringified value.
      typeof value === 'number' ? value.split(',') : value
    );
  };

  // Buscar el reporte
  const handleChargeProReport = () => {
    setBlocking(true);
    let data = {
      id: charge_id,
      startDate: formatDate(selectedStartDateReport),
      endDate: formatDate(selectedEndDateReport),
      lines: phases,
      harmonics: harmonics,
      types: typeData,
    };
    dispatch(getChargeProReport(data, setBlocking));
  };
  // Buscar el reporte
  const handleChargeProReportPDF = () => {
    setBlocking(true);
    let data = {
      id: charge_id,
      startDate: formatDate(selectedStartDateReport),
      endDate: formatDate(selectedEndDateReport),
      lines: phases,
      harmonics: harmonics,
      types: typeData,
      contact: contact,
    };
    dispatch(getChargeProReportPDF(data, setBlocking));
  };

  // Al cargar el componente, se obtienen los datos de la tienda Redux
  useEffect(() => {
    if (charge_id) {
      if (!hasInitialized.current) {
        hasInitialized.current = true;

        // const now = new Date();
        // const startOfDay = new Date(now);
        // startOfDay.setHours(0, 0, 0, 0);

        // setSelectedStartDate(startOfDay);
        // setSelectedEndDate(new Date(now));

        dispatch(
          getChargeDashboard10MinutalPro(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
        dispatch(
          getChargeDashboard5MinutalPro(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
        dispatch(
          getChargeDashboardHarmonicPro(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
        dispatch(
          getChargeDashboardProFlickerPlt(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
      } else {
        dispatch(
          getChargeDashboard10MinutalPro(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
        dispatch(
          getChargeDashboard5MinutalPro(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
        dispatch(
          getChargeDashboardHarmonicPro(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
        dispatch(
          getChargeDashboardProFlickerPlt(
            charge_id,
            formatDate(selectedStartDate),
            formatDate(selectedEndDate)
          )
        );
      }
    }
  }, [dispatch, charge_id, selectedStartDate, selectedEndDate]);

  // Verificar si hay eventos de notificación cada 5 minutos
  useEffect(() => {
    if (charge.charge.created_at) {
      // Ejecutar inmadiatamente al cargar el componente
      // Obtener la fecha actual desde las 00:00:00 hasta la hora actual
      let now = new Date();
      now.setHours(0, 0, 0, 0);
      // let startDate = new Date(now);
      // Establecer la Fecha de Inicio como el inicio del día actual
      let endDate = new Date();

      dispatch(
        getChargeDashboardNotification(
          charge_id,
          formatDate(new Date(charge?.charge?.created_at)),
          formatDate(selectedEndDate)
        )
      );

      // Ejecutar cada 5 minutos
      const interval = setInterval(
        () => {
          // Actualizar las fechas de fin
          endDate = new Date();
          // Hacer la petición para obtener las notificaciones
          dispatch(
            getChargeDashboardNotification(
              charge_id,
              formatDate(new Date(charge?.charge?.created_at)),
              formatDate(endDate)
            )
          );
        },
        5 * 60 * 1000
      );

      // Limpiar el intervalo al desmontar el componente
      return () => clearInterval(interval);
    }
  }, [charge_id, charge]);

  if (TenMinutalLoading || FiveMinutalLoading || HarmonicLoading) {
    return (
      <DashboardLayout>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100vh"
          flexDirection="column"
          gap="4"
        >
          <CircularProgress color="secondary" size={50} />
          <Typography variant="h3">Cargando...</Typography>
        </Box>
      </DashboardLayout>
    );
  }

  // Descargar captura en PDF
  const handlePDF = () => {
    setTimeout(() => {
      const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        },
      });

      Toast.fire({
        icon: 'info',
        title: 'Descargando...',
        text: 'Por favor espere',
      });

      html2canvas(dashboardRef.current, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height - 750]);

        pdf.addImage(imgData, 'PNG', 0, 0, canvas.width, canvas.height - 750);
        pdf.save(`${charge.name}.pdf`);
        // Mostrar mensaje de éxito
        Toast.fire({
          icon: 'success',
          title: 'Descarga completa',
          text: 'Se ha descargado correctamente la gráfica',
        });
      });
    }, 100);
  };

  // Abrir modal de eventos
  const handleEventsModal = () => {
    setOpenEvents(!openEvents);
  };

  // Obtener el nombre del archivo
  function getFileName(disposition) {
    let filename = null;
    if (disposition && disposition.indexOf('attachment') !== -1) {
      var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      var matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, '');
      }
    }

    return filename;
  }

  // Descargar Reporte de Eventos
  const handleDownloadEvents = () => {
    setBlocking(true);
    console.log('Evento Inicio');

    axios
      .post(
        'https://api.metimur.mx/api/pqcharge/charge/events',
        {
          charge_id: charge_id,
          start_date: 202504301846,
          end_date: 202506161041,
          export: true,
        },
        {
          headers: { Authorization: 'Bearer ' + getToken() },
          responseType: 'arraybuffer',
        }
      )
      .then((response) => {
        console.log('Evento Termina');

        const typeApp =
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        const downloadUrl = window.URL.createObjectURL(
          new Blob([response.data], { type: typeApp })
        );
        const link = document.createElement('a');
        const fileName =
          getFileName(response.headers['content-disposition']) ||
          'reporte.xlsx';
        link.href = downloadUrl;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        setBlocking(false);
      })
      .catch((error) => {
        console.log(error);
        console.log('Evento Termina 2');
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.message || 'No se pudo descargar el archivo.',
        });
        setBlocking(false);
      });
  };

  // Renderización del componente
  return (
    <DashboardLayout>
      <Grid2 container={true} spacing={4} p={4}>
        {/** Titulo de la página */}
        <Grid2
          size={12}
          display="flex"
          gap={2}
          justifyContent="space-between"
          alignItems="center"
        >
          <Box display="flex" gap={2} alignItems="center">
            {/** Titulo de la página */}
            <Typography variant="h3" sx={{ color: '#A53693' }}>
              Calidad de Energía
            </Typography>
            <Box gap={2} display="flex">
              {/** Icono de descarga de captura en PDF */}
              <Button
                size="small"
                onClick={() => handlePDF()}
                color="secondary"
                variant="contained"
                sx={{
                  color: 'white',
                  fontWeight: 'bold',
                  minWidth: '0',
                  borderRadius: '50%',
                  maxHeight: '35px',
                  p: 0.5,
                }}
                aria-label="download"
              >
                <PDF />
              </Button>
              {/** Botón de compartir */}
              <ShareButton name={charge.name} itemRef={dashboardRef} />
            </Box>
          </Box>
          {/** Botón de eventos */}
          <Box display="flex" gap={2}>
            <Badge badgeContent={Notification.length} color="primary" showZero>
              <Button
                size="small"
                variant="contained"
                color="secondary"
                onClick={handleEventsModal}
              >
                Eventos
              </Button>
            </Badge>
          </Box>
        </Grid2>
        {/** Breadcrumbs de la página */}
        <Box display="flex">
          {isAllowed(user.permissions, ['corporative_read']) && meter && (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ marginRight: theme.spacing(1) }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                sx={{ color: '#A53693', textDecoration: 'none' }}
                to={`/corporative/${meter.corporative_id}`}
                state={meter}
              >
                {intl.formatMessage({ id: 'app.groups.nav.meters' })}
              </LinkMaterial>
              <LinkMaterial
                color="inherit"
                component={NavLink}
                sx={{ textDecoration: 'none' }}
                to={`/meter/${meter.id}`}
                state={meter}
              >
                {meter
                  ? meter.name
                  : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
              </LinkMaterial>
              <Typography sx={{ fontWeight: 600, color: '#00AFEF' }}>
                {' '}
                |{' '}
              </Typography>
            </Breadcrumbs>
          )}
          {meter && (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ marginLeft: theme.spacing(1), color: '#A53693' }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                to={`/meter/${meter.id}`}
                state={meter}
                sx={{ textDecoration: 'none' }}
              >
                {intl.formatMessage({ id: 'app.charges.nav.groupLab2' })}
              </LinkMaterial>
              <LinkMaterial
                component={NavLink}
                sx={{ textDecoration: 'none', color: '#66788A' }}
                to={`/group/${group.id}`}
                state={{
                  group: group,
                  meter: meter,
                }}
              >
                {group
                  ? group.name
                  : intl.formatMessage({ id: 'app.charges.nav.chargeLab2' })}
              </LinkMaterial>
              <Typography sx={{ fontWeight: 600, color: '#00AFEF' }}>
                {' '}
                |{' '}
              </Typography>
            </Breadcrumbs>
          )}
          {meter ? (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ marginLeft: theme.spacing(1), color: '#A53693' }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                to={`/group/${group.id}`}
                state={{
                  group: group,
                  meter: meter,
                }}
                sx={{ textDecoration: 'none' }}
              >
                {intl.formatMessage({
                  id: 'app.reports.hourReports.chargeLbl',
                })}
              </LinkMaterial>
              <Typography variant="h5">
                {charge
                  ? charge.name
                  : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
              </Typography>
            </Breadcrumbs>
          ) : (
            <Breadcrumbs
              arial-label="breadcrumb"
              separator=":"
              sx={{ color: '#A53693' }}
            >
              <LinkMaterial
                color="inherit"
                component={NavLink}
                to={user.home_url}
                sx={{ textDecoration: 'none' }}
              >
                {intl.formatMessage({
                  id: 'app.reports.hourReports.chargeLbl',
                })}
              </LinkMaterial>
              <Typography variant="h5">
                {charge
                  ? charge.name
                  : intl.formatMessage({ id: 'app.groups.nav.groupLab2' })}
              </Typography>
            </Breadcrumbs>
          )}
        </Box>
        {/** Buscador de fechas */}
        <Grid2 size={12} display="flex" justifyContent="flex-start" gap={2}>
          <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={locale}
          >
            {/** Campos de fecha inicio */}
            <Grid2 size={2}>
              <DateTimePicker
                label="Fecha de Inicio"
                defaultValue={selectedStartDate}
                sx={{
                  width: '100%',
                  '& label': {
                    color: '#00AFEF',
                    fontSize: '1.2rem',
                    backgroundColor: '#f8fafc',
                    pr: 1,
                  },
                  '& fieldset': {
                    border: '1px solid rgb(0,175,239)',
                    '&:hover': {
                      borderColor: '#00AFEF',
                    },
                  },
                  '& .MuiIconButton-edgeEnd': {
                    color: '#00AFEF',
                  },
                }}
                timeSteps={{ minutes: 10 }}
                onChange={handleStartDateChange}
                maxDate={new Date()}
                // minDate={
                //   // 14 dias antes que hoy
                //   new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)
                // }
                slotProps={{
                  textField: {
                    helperText: 'La Consulta esta Limitada a 14 Días Atrás',
                  },
                }}
              />
            </Grid2>
            {/** Campo de fecha fin */}
            <Grid2 size={2}>
              <DateTimePicker
                label="Fecha de Fin"
                defaultValue={selectedEndDate}
                sx={{
                  width: '100%',
                  '& label': {
                    color: '#00AFEF',
                    fontSize: '1.2rem',
                    backgroundColor: '#f8fafc',
                    pr: 1,
                  },
                  '& fieldset': {
                    border: '1px solid rgb(0,175,239)',
                    '&:hover': {
                      borderColor: '#00AFEF',
                    },
                  },
                  '& .MuiIconButton-edgeEnd': {
                    color: '#00AFEF',
                  },
                }}
                timeSteps={{ minutes: 10 }}
                onChange={handleEndDateChange}
                maxDate={new Date()}
                minDate={selectedStartDate}
                // minDate={
                //   // 14 dias antes que hoy
                //   new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)
                // }
              />
            </Grid2>
          </LocalizationProvider>
        </Grid2>
        {!TenMinutalError && !FiveMinutalError && !HarmonicError ? (
          <Box
            ref={dashboardRef}
            width="100%"
            display="flex"
            flexDirection="row"
            flexWrap="wrap"
            gap={4}
          >
            <Grid2 size={12}>
              <Frecuency frecuencyData={TenMinutal} />
            </Grid2>
            <Grid2 size={12}>
              <TenMinutalChart title="Flicker Short Term" data={TenMinutal} />
            </Grid2>
            <Grid2 size={12}>
              <TenMinutalChart title="Flicker Long Term" data={FlickerPlt} />
            </Grid2>
            <Grid2 size={12}>
              <TenMinutalChart title="THD Corriente" data={TenMinutal} />
            </Grid2>
            <Grid2 size={12}>
              <TenMinutalChart title="THD Voltaje" data={TenMinutal} />
            </Grid2>
            <Grid2 size={12}>
              <LineChart title="Corriente RMS" dataChart={FiveMinutal} />
            </Grid2>
            <Grid2 size={12}>
              <LineChart title="Voltaje RMS" dataChart={FiveMinutal} />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
              <HarmonicChart
                title="Voltage Harmonic"
                data={Harmonic}
                color="rgb(0, 175, 239)"
                icon={
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '40px',
                    }}
                  >
                    <img
                      alt="Voltage"
                      src="/images/lessThan.svg"
                      width={40}
                      height={40}
                      style={{
                        transform: 'rotate(-90deg)',
                      }}
                    />
                    <Typography
                      sx={{
                        position: 'absolute',
                        bottom: '0%',
                        right: '0%',
                        color: 'rgb(0, 175, 239)',
                      }}
                      fontWeight="bold"
                    >
                      H
                    </Typography>
                  </div>
                }
                footer="Haz Click para ver el Armónico de Voltaje"
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
              <HarmonicChart
                title="Current Harmonic"
                data={Harmonic}
                color="#ed685e"
                icon={
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '40px',
                    }}
                  >
                    <IconSVG
                      style={{
                        fill: '#ed685e',
                        height: '40px',
                        width: '40px',
                      }}
                    />
                    <Typography
                      sx={{
                        position: 'absolute',
                        bottom: '-10%',
                        right: '-5%',
                        color: '#ed685e',
                      }}
                      fontWeight="bold"
                    >
                      H
                    </Typography>
                  </div>
                }
                footer="Haz Click para ver el Armónico de Corriente"
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
              <HarmonicChart
                title="Voltage InterHarmonic"
                data={Harmonic}
                color="#EAAB36"
                icon={
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '40px',
                    }}
                  >
                    <img
                      alt="Voltage"
                      src="/images/lessThan2.svg"
                      width={40}
                      height={40}
                      style={{
                        transform: 'rotate(-90deg)',
                      }}
                    />
                    <Typography
                      sx={{
                        position: 'absolute',
                        bottom: '0%',
                        right: '-10%',
                        color: '#EAAB36',
                      }}
                      fontWeight="bold"
                    >
                      IH
                    </Typography>
                  </div>
                }
                footer="Haz Click para ver el InterArmónico de Voltaje"
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 6, xs: 12 }}>
              <HarmonicChart
                title="Current InterHarmonic"
                data={Harmonic}
                color="rgb(165, 54, 147)"
                icon={
                  <div
                    style={{
                      position: 'relative',
                      width: '40px',
                      height: '40px',
                    }}
                  >
                    <IconSVG
                      style={{
                        fill: 'rgb(165, 54, 147)',
                        height: '40px',
                        width: '40px',
                      }}
                    />
                    <Typography
                      sx={{
                        position: 'absolute',
                        bottom: '-10%',
                        right: '-15%',
                        color: 'rgb(165, 54, 147)',
                      }}
                      fontWeight="bold"
                    >
                      IH
                    </Typography>
                  </div>
                }
                footer="Haz Click para ver el InterArmónico de Corriente"
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 12, xs: 12 }}>
              <Card
                bgColor="rgb(69, 184, 128)"
                data=" "
                title="Datos de Calidad de Energía"
                icon={<Description color="success" fontSize="large" />}
                footer="Haz Click para Descargar el Reporte en Excel"
                action={handleOpenReport}
                clicked={true}
              />
            </Grid2>
            <Grid2 size={{ lg: 3, md: 12, xs: 12 }}>
              <Card
                bgColor="#ed685e"
                data=" "
                title="Roporte de Calidad de Energía"
                icon={<Description fontSize="large" sx={{ fill: '#ed685e' }} />}
                footer="Haz Click para Descargar el Reporte en PDF"
                action={handleOpenReportPDF}
                clicked={true}
              />
            </Grid2>
          </Box>
        ) : (
          <Grid2
            size={12}
            display="flex"
            justifyContent="center"
            flexDirection="column"
            alignItems="center"
            width="100%"
            height="65vh"
            p={4}
            gap={4}
          >
            <ErrorOutline color="error" sx={{ fontSize: '8.5rem' }} />
            <Typography variant="h2">Error en la busqueda</Typography>
            <Typography variant="caption" color="error">
              Reintenta otra fecha
            </Typography>
          </Grid2>
        )}
        {/** Contenido de la página */}
      </Grid2>
      {/* Modal Calidad de energia */}
      <Dialog
        open={openReport}
        onClose={handleCloseReport}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          id="alert-dialog-title"
          display="flex"
          justifyContent="space-between"
          flexDirection="row"
          alignItems="center"
        >
          <Chip
            label="Datos de Calidad de Energía"
            sx={{
              fontWeight: 600,
              color: 'white',
              bgcolor: 'rgb(165, 54, 147)',
              fontSize: '16px',
            }}
          />
          <IconButton onClick={handleCloseReport}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid2 container spacing={2} p={4}>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={locale}
            >
              <Grid2 size={6}>
                <DateTimePicker
                  label="Fecha de Inicio"
                  defaultValue={selectedStartDateReport}
                  sx={{ width: '100%' }}
                  timeSteps={{ minutes: 10 }}
                  onChange={handleStartDateChangeReport}
                  maxDate={new Date()}
                  minDate={
                    new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)
                  }
                  slotProps={{
                    textField: {
                      helperText: 'La Consulta esta Limitada a 14 Días Atrás',
                    },
                  }}
                />
              </Grid2>
              <Grid2 size={6}>
                <DateTimePicker
                  label="Fecha de Fin"
                  defaultValue={selectedEndDateReport}
                  sx={{ width: '100%' }}
                  timeSteps={{ minutes: 10 }}
                  onChange={handleEndDateChangeReport}
                  maxDate={new Date()}
                  minDate={
                    new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)
                  }
                />
              </Grid2>
            </LocalizationProvider>

            {/* Tipo de Datos */}
            <Grid2 size={6}>
              <FormControl fullWidth>
                <InputLabel id="type-data-label">Tipos de Datos</InputLabel>
                <Select
                  labelId="type-data-label"
                  multiple
                  value={typeData}
                  onChange={handleChangeTypeData}
                  input={<OutlinedInput label="Tipos de Datos" />}
                  renderValue={(selected) =>
                    selected.map((val) => typeDataLabels[val] || val).join(', ')
                  }
                >
                  {Object.entries(typeDataLabels).map(([value, label]) => (
                    <MenuItem key={value} value={value}>
                      <Checkbox checked={typeData.includes(value)} />
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            {/* Fases */}
            <Grid2 size={6}>
              <FormControl fullWidth>
                <InputLabel id="phases-label">Fases</InputLabel>
                <Select
                  labelId="phases-label"
                  multiple
                  value={phases}
                  onChange={handleChangePhases}
                  input={<OutlinedInput label="Fases" />}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {['L1', 'L2', 'L3'].map((fase, i) => (
                    <MenuItem key={fase} value={fase}>
                      <Checkbox checked={phases.includes(fase)} />
                      Fase {i + 1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            {/* Armónicos */}
            {(typeData.includes('v_Harmonics') ||
              typeData.includes('i_Harmonics') ||
              typeData.includes('v_InterHarmonics') ||
              typeData.includes('i_InterHarmonics')) && (
              <Grid2 size={12}>
                <FormControl fullWidth>
                  <InputLabel id="harmonics-label">Armónicos</InputLabel>
                  <Select
                    labelId="harmonics-label"
                    multiple
                    value={harmonics}
                    onChange={handleChangeHarmonics}
                    input={<OutlinedInput label="Armónicos" />}
                    renderValue={(selected) =>
                      selected.map((h) => `H${h + 1}`).join(', ')
                    }
                  >
                    {Array.from({ length: 39 }, (_, i) => i + 1).map((item) => (
                      <MenuItem key={item} value={item}>
                        <Checkbox checked={harmonics.includes(item)} />H
                        {item + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid2>
            )}
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseReport}
            variant="outlined"
            color="secondary"
          >
            Cerrar
          </Button>
          <Button
            onClick={handleChargeProReport}
            variant="contained"
            color="secondary"
            loading={isBlocking}
            disabled={isBlocking}
            loadingPosition="start"
          >
            {isBlocking ? 'Descargando...' : 'Descargar Reporte'}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Modal Reporte de Calidad de energia */}
      <Dialog
        open={openReportPDF}
        onClose={handleCloseReportPDF}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="md"
      >
        <DialogTitle
          id="alert-dialog-title"
          display="flex"
          justifyContent="space-between"
          flexDirection="row"
          alignItems="center"
        >
          <Chip
            label="Reporte de Calidad de Energía"
            sx={{
              fontWeight: 600,
              color: 'white',
              bgcolor: 'rgb(165, 54, 147)',
              fontSize: '16px',
            }}
          />
          <IconButton onClick={handleCloseReportPDF}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid2 container spacing={2} p={4}>
            <LocalizationProvider
              dateAdapter={AdapterDateFns}
              adapterLocale={locale}
            >
              <Grid2 size={6}>
                <DateTimePicker
                  label="Fecha de Inicio"
                  defaultValue={selectedStartDateReport}
                  sx={{ width: '100%' }}
                  timeSteps={{ minutes: 10 }}
                  onChange={handleStartDateChangeReport}
                  maxDate={new Date()}
                  minDate={
                    new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)
                  }
                  slotProps={{
                    textField: {
                      helperText: 'La Consulta esta Limitada a 14 Días Atrás',
                    },
                  }}
                />
              </Grid2>
              <Grid2 size={6}>
                <DateTimePicker
                  label="Fecha de Fin"
                  defaultValue={selectedEndDateReport}
                  sx={{ width: '100%' }}
                  timeSteps={{ minutes: 10 }}
                  onChange={handleEndDateChangeReport}
                  maxDate={new Date()}
                  minDate={
                    new Date(new Date().getTime() - 14 * 24 * 60 * 60 * 1000)
                  }
                />
              </Grid2>
            </LocalizationProvider>

            {/* Tipo de Datos */}
            <Grid2 size={6}>
              <FormControl fullWidth>
                <InputLabel id="type-data-label">Tipos de Datos</InputLabel>
                <Select
                  labelId="type-data-label"
                  multiple
                  value={typeData}
                  onChange={handleChangeTypeData}
                  input={<OutlinedInput label="Tipos de Datos" />}
                  renderValue={(selected) =>
                    selected.map((val) => typeDataLabels[val] || val).join(', ')
                  }
                >
                  {Object.entries(typeDataLabels).map(([value, label]) => (
                    <MenuItem key={value} value={value}>
                      <Checkbox checked={typeData.includes(value)} />
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            {/* Fases */}
            <Grid2 size={6}>
              <FormControl fullWidth>
                <InputLabel id="phases-label">Fases</InputLabel>
                <Select
                  labelId="phases-label"
                  multiple
                  value={phases}
                  onChange={handleChangePhases}
                  input={<OutlinedInput label="Fases" />}
                  renderValue={(selected) => selected.join(', ')}
                >
                  {['L1', 'L2', 'L3'].map((fase, i) => (
                    <MenuItem key={fase} value={fase}>
                      <Checkbox checked={phases.includes(fase)} />
                      Fase {i + 1}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid2>

            {/* Armónicos */}
            {(typeData.includes('v_Harmonics') ||
              typeData.includes('i_Harmonics') ||
              typeData.includes('v_InterHarmonics') ||
              typeData.includes('i_InterHarmonics')) && (
              <Grid2 size={12}>
                <FormControl fullWidth>
                  <InputLabel id="harmonics-label">Armónicos</InputLabel>
                  <Select
                    labelId="harmonics-label"
                    multiple
                    value={harmonics}
                    onChange={handleChangeHarmonics}
                    input={<OutlinedInput label="Armónicos" />}
                    renderValue={(selected) =>
                      selected.map((h) => `H${h + 1}`).join(', ')
                    }
                  >
                    {Array.from({ length: 39 }, (_, i) => i + 1).map((item) => (
                      <MenuItem key={item} value={item}>
                        <Checkbox checked={harmonics.includes(item)} />H
                        {item + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid2>
            )}

            {/* Contactos */}
            {/* Agregar Contacto (Nombre y Correo) */}
            <Grid2 size={6}>
              <FormControl fullWidth variant="standard">
                <TextField
                  id="contact-label"
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                  placeholder="Nombre"
                  label="Nombre"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Person />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Grid2>
            <Grid2 size={6}>
              <FormControl fullWidth variant="standard">
                <TextField
                  id="contact-label"
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                  placeholder="Correo Electrónico"
                  label="Correo Electrónico"
                  slotProps={{
                    input: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <Email />
                        </InputAdornment>
                      ),
                    },
                  }}
                />
              </FormControl>
            </Grid2>
            <Grid2 size={12} spacing={0}>
              <Typography variant="h5">Enviar a:</Typography>
            </Grid2>
            {/* Lista de contactos */}
            {contact?.length > 0 && (
              <Grid2 size={12} display="flex" flexDirection="column" gap={2}>
                {contact?.map((item, index) => (
                  <Box
                    key={index}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    gap={2}
                  >
                    <Typography variant="h6">{item.name}</Typography>
                    <Typography variant="subtitle1">{item.email}</Typography>
                    <IconButton>
                      <Delete onClick={() => handleRemoveContact(index)} />
                    </IconButton>
                  </Box>
                ))}
              </Grid2>
            )}
            <Button
              variant="contained"
              color="secondary"
              size="large"
              fullWidth={true}
              startIcon={<Add />}
              onClick={handleAddContact}
              disabled={!contactName || !contactEmail}
            >
              Agregar Destinatario
            </Button>
          </Grid2>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleCloseReportPDF}
            variant="outlined"
            color="secondary"
          >
            Cerrar
          </Button>
          <Button
            onClick={handleChargeProReportPDF}
            variant="contained"
            color="secondary"
            loading={isBlocking}
            disabled={isBlocking}
            loadingPosition="start"
          >
            {isBlocking ? 'Enviando...' : 'Enviar Reporte'}
          </Button>
        </DialogActions>
      </Dialog>
      {/* Modal Eventos */}
      <Events
        openEvents={openEvents}
        handleEventsModal={handleEventsModal}
        events={Notification}
        handleDownloadEvents={handleDownloadEvents}
        isBlocking={isBlocking}
      />
    </DashboardLayout>
  );
}
